import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {Chart,registerables} from 'chart.js';

@Component({
  selector: 'sm-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit {
  public chart: any;
  canvas: any;
  ctx: any;
  @Input() dataSource: any = {}
  // @ViewChild('mychart') mychart:any;
  @ViewChild('mychart', {static: false}) mychart!: ElementRef;
  constructor() { }

  ngOnInit(): void {
    // this.createChart();
  }


// ngAfterViewInit() {
//   if(this.dataSource.labels.length == 0){

//   }
// setTimeout(() => {
//   console.log(this.dataSource);
//   Chart.register(...registerables);
//   this.canvas = this.mychart.nativeElement;

// this.ctx = this.canvas.getContext('2d');
// const labelCount = this.dataSource.labels.length;
//     const rowHeight = 50; // px per label
//     const minHeight = 300; // minimum chart height
//     const chartHeight = Math.max(labelCount * rowHeight, minHeight);
    
//     this.canvas.height = chartHeight;
//     new Chart(this.ctx, {
//     type: 'line',
//     data: this.dataSource,
//     options: {
//       plugins:{
//         legend: {
//         display: true,
//         position: 'bottom'
//       },

//       },
//       indexAxis: 'y',
//       scales: {
//         x: {
//           beginAtZero: true
//         }
//       },
    
//     responsive:true,
//     maintainAspectRatio:false
 
//   }

// });
// }, 100);

// }
ngAfterViewInit() {
  if(this.dataSource.labels.length == 0){

  }
setTimeout(() => {
  console.log(this.dataSource);
  Chart.register(...registerables);
  this.canvas = this.mychart.nativeElement;

this.ctx = this.canvas.getContext('2d');
// const labelCount = this.dataSource.labels.length;
//     const rowHeight = 50; // px per label
//     const minHeight = 300; // minimum chart height
//     const chartHeight = Math.max(labelCount * rowHeight, minHeight);
    
//     this.canvas.height = chartHeight;
    new Chart(this.ctx, {
    type: 'line',
    data: this.dataSource,
    options: {
      plugins:{
        legend: {
        display: true,
        position: 'bottom'
      },

      },
      // indexAxis: 'y',
      // scales: {
      //   x: {
      //     beginAtZero: true
      //   }
      // },
    
    responsive:true,
    maintainAspectRatio:false
 
  }

});
}, 100);

}

 

}
